import './tailwind.css'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

import React from 'react'

import { createRoot } from 'react-dom/client'

import App from './App'
import initLogging from './logging'

initLogging()

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element')
const root = createRoot(container)
root.render(<App />)
